import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { ContractService } from '../../services/contract.service';

@Component({
  selector: 'app-discard-confirmation-dialog',
  templateUrl: './discard-confirmation-dialog.component.html',
  styleUrls: ['./discard-confirmation-dialog.component.scss']
})
export class DiscardConfirmationDialogComponent implements OnInit {

  constructor(
    public dialoge:MatDialog,
    public notifier: NotifierService,
    private router: Router,
    public contractService: ContractService,
    @Inject(MAT_DIALOG_DATA) public data:any
  ) {
    
   }

  ngOnInit(): void {
  }

  doNotDiscardContract(){ 
    this.dialoge.closeAll();
   }

  onContractDiscard(){
    let body = {"uuid":this.data.uuid,"version":this.data.selectedVersion};
    this.contractService.onDiscardContractVersion(body).subscribe((result) => {
      if (result["status"] == 1) {
        this.notifier.notify('success','Version removed successfully!');
        this.contractService.onContractDetailsReloadEmitter();
        this.dialoge.closeAll();
      }else{
        this.notifier.notify('error','Something went wrong !');
        this.dialoge.closeAll();
      }
    }, err => {
      this.notifier.notify('error','Something went wrong !');
      this.dialoge.closeAll();
    })
  }

}
